import { ApiResponse, TicketManagerComment } from '@vision/ui/interfaces';
import { createHttpExtraOptions } from '../../../utils';
import { TicketManagerApi } from '../ticket-manager.api';
import {
  TicketManagerTicketCommentsArgs,
  TicketManagerTicketCreateCommentArgs,
  TicketManagerTicketDeleteCommentArgs,
  TicketManagerTicketDeleteCommentResponse,
} from './ticket-comments.api.types';
import {
  normalizeTicketManagerTicketCommentResponse,
  normalizeTicketManagerTicketCommentsResponse,
  TicketManagerTicketCommentResponseEnvelope,
  TicketManagerTicketCommentsResponseEnvelope,
} from './ticket-comments.mappers';
import {
  buildTicketManagerTicketCommentsRequest,
  buildTicketManagerTicketCreateCommentRequest,
  buildTicketManagerTicketDeleteCommentRequest,
} from './ticket-comments.routes';

const mutationExtraOptions = createHttpExtraOptions({
  notification: {
    autoHandleSuccess: false,
  },
});

export const TicketCommentsEndpoints = TicketManagerApi.injectEndpoints({
  endpoints: (builder) => ({
    ticketManagerTicketComments: builder.query<ApiResponse<TicketManagerComment[]>, TicketManagerTicketCommentsArgs>({
      query: ({ projectId, ticketId }) => buildTicketManagerTicketCommentsRequest({ projectId, ticketId }),
      transformResponse: (response: TicketManagerTicketCommentsResponseEnvelope) =>
        normalizeTicketManagerTicketCommentsResponse(response),
      providesTags: (_result, _error, { ticketId }) => [{ type: 'TicketManagerTicketComments', id: ticketId }],
    }),
    createTicketManagerTicketComment: builder.mutation<
      ApiResponse<TicketManagerComment>,
      TicketManagerTicketCreateCommentArgs
    >({
      query: ({ body, projectId, ticketId }) => ({
        ...buildTicketManagerTicketCreateCommentRequest({ body, projectId, ticketId }),
        extraOptions: mutationExtraOptions,
      }),
      transformResponse: (response: TicketManagerTicketCommentResponseEnvelope) =>
        normalizeTicketManagerTicketCommentResponse(response),
      invalidatesTags: (_result, _error, { ticketId }) => [{ type: 'TicketManagerTicketComments', id: ticketId }],
    }),
    deleteTicketManagerTicketComment: builder.mutation<
      TicketManagerTicketDeleteCommentResponse,
      TicketManagerTicketDeleteCommentArgs
    >({
      query: ({ commentId, projectId, ticketId }) => ({
        ...buildTicketManagerTicketDeleteCommentRequest({ commentId, projectId, ticketId }),
        extraOptions: mutationExtraOptions,
      }),
      invalidatesTags: (_result, _error, { ticketId }) => [{ type: 'TicketManagerTicketComments', id: ticketId }],
    }),
  }),
});

export const {
  useCreateTicketManagerTicketCommentMutation,
  useDeleteTicketManagerTicketCommentMutation,
  useTicketManagerTicketCommentsQuery,
} = TicketCommentsEndpoints;
